import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import * as React from 'react';
import { transl } from '../../main/transl';
import { commSvc } from '../../services/CommSvc';
import { getOmnistore } from '../../stores/Omnistore';

@observer class _MessageDetailDialog extends React.Component<{classes: any, entity: any, onClose: () => void}> {//TODO
	_toggleRead = () => {
		const {entity, onClose} = this.props;
		const isRead = entity.isRead;
		commSvc.doPost('UpdateMessage', {...entity, isRead: !entity.isRead})
			.then(r => {
				const multirepo = getOmnistore().multirepo;
				const messageRepo = multirepo.messageRepo;
				onClose();
				messageRepo.fetchDirect();
			});
	}

	_go = () => {
		const {entity, onClose} = this.props;
		onClose();
		const multirepo = getOmnistore().multirepo;
		const locationStore = getOmnistore().locationStore;
		switch (entity.type) {
		case 'ADVERTISEMENT': {
			const a = multirepo.advertisementRepo.byId(entity.parameter);
			if (!a) {
				console.error('No such advertisement', entity.parameter);
				return;
			}
			getOmnistore().locationStore.setPage('AdsPage');
			// advertisementRepo.rowClick(a.id)//TODO
		} break;
		case 'TEMPLATE_REMINDER_ALARM':
		case 'NEW_TEMPLATE_REMINDER': {
			const t = multirepo.templateRepo.byId(entity.parameter);
			if (!t) {
				console.error('No such template', entity.parameter);
				return;
			}
			locationStore.setPage('LTemplates');
			locationStore.setBranchId(t.branchId);
			locationStore.setSupplierId(t.supplierId);
		} break;
		default: console.error('Unknown message type', entity.type);
		}
	}

	render() {
		const {classes, entity, onClose} = this.props;
		if (!entity) return null;
		const isRead = entity.isRead;
		return <Dialog open={true} className={classes.root} onClose={onClose}>
			<DialogTitle>{transl('Message_Type.' + entity.type)}</DialogTitle>
			<DialogContent className={classes.content}>
				<div className={classes.text}>{entity.creationTimestamp}</div>
				<div className={classes.text}>{entity.subject}</div>
				<div className={classes.text}>{entity.text}</div>
				<div className={classes.text}>{transl(isRead ? 'message.read' : 'message.unread')}</div>
			</DialogContent>
			<DialogActions>
				<Button color="primary" onClick={this._go}>{transl('message.go.' + entity.type)}</Button>
				{!isRead ? null : <Button onClick={this._toggleRead}>{transl('message.makeUnread')}</Button>}
			</DialogActions>
		</Dialog>;
	}
}

const styles = createStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
	},
	text: {
		flex: '1 0',
		margin: 10,
		width: '100%',
	},
	input: {
		flex: '1 0',
		margin: 10,
		width: '100%',
	},
});

export const MessageDetailDialog = withStyles(styles)(_MessageDetailDialog);
